import { Button, Form, Select } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setPerfil } from "../../../../redux/slices/persisted/persistedSlice";
import { useNavigate } from "react-router-dom";

const Perfil = () => {
  //estados globais
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  //estados locais
  const [form] = Form.useForm();

  const submit = (values: any) => {
    dispatch(setPerfil(values.perfil));
    navigate("/painelGeral");
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Form.Item
        label="Selecione o perfil"
        name="perfil"
        rules={[
          {
            required: true,
            message: "Selecione um perfil",
          },
        ]}
      >
        <Select
          autoFocus
          optionFilterProp="label"
          placeholder="Selecione qual perfil que deseja entrar"
          options={persistedState.user.perfis?.map((item: string) => ({
            value: item,
            label: item,
          }))}
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" className="submitButton">
          Selecionar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Perfil;
